import { render, staticRenderFns } from "./SignUpLogs.vue?vue&type=template&id=4db88422&"
import script from "./SignUpLogs.vue?vue&type=script&lang=js&"
export * from "./SignUpLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SignUpLogs.vue"
export default component.exports